module.exports = __webpack_public_path__ + "img/detail_right.c0b3a18f.png";